"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoctorProfile = exports.NotificationPreferences = exports.AvailabilityBlock = void 0;
const constants_1 = require("../../constants");
const property_1 = require("../../decorators/property");
const notification_settings_1 = require("./notification.settings");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const restricted_1 = require("../../decorators/restricted");
const searchable_1 = require("../../decorators/searchable");
const mocks_1 = require("../../mocks");
class AvailabilityBlock {
}
exports.AvailabilityBlock = AvailabilityBlock;
__decorate([
    (0, class_validator_1.IsEnum)(constants_1.DayOfWeek),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ type: Number, enum: constants_1.DayOfWeek }),
    __metadata("design:type", Number)
], AvailabilityBlock.prototype, "dayOfWeek", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, {
        message: 'startTime must be in HH:mm format (e.g., 08:30 or 23:15)',
    }),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], AvailabilityBlock.prototype, "startTime", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, {
        message: 'endTime must be in HH:mm format (e.g., 08:30 or 23:15)',
    }),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], AvailabilityBlock.prototype, "endTime", void 0);
class NotificationPreferences {
}
exports.NotificationPreferences = NotificationPreferences;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => notification_settings_1.NotificationSettings),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)(),
    __metadata("design:type", notification_settings_1.NotificationSettings)
], NotificationPreferences.prototype, "newPatient", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => notification_settings_1.NotificationSettings),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)(),
    __metadata("design:type", notification_settings_1.NotificationSettings)
], NotificationPreferences.prototype, "workTimeNear", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => notification_settings_1.NotificationSettings),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)(),
    __metadata("design:type", notification_settings_1.NotificationSettings)
], NotificationPreferences.prototype, "workTimeEnded", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => notification_settings_1.NotificationSettings),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)(),
    __metadata("design:type", notification_settings_1.NotificationSettings)
], NotificationPreferences.prototype, "workTimeStarted", void 0);
class DoctorProfile {
}
exports.DoctorProfile = DoctorProfile;
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_transformer_1.Type)(() => NotificationPreferences),
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, property_1.Property)(),
    __metadata("design:type", NotificationPreferences)
], DoctorProfile.prototype, "notificationPreferences", void 0);
__decorate([
    (0, property_1.Property)({ default: false }),
    __metadata("design:type", Boolean)
], DoctorProfile.prototype, "ready", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [mocks_1.ObjectId], default: [] }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "specializationIds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DoctorProfile.prototype, "visitFeeAmount", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DoctorProfile.prototype, "feeShareAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, searchable_1.Searchable)(),
    (0, property_1.Property)({ index: true, unique: true, sparse: true }),
    __metadata("design:type", String)
], DoctorProfile.prototype, "code", void 0);
__decorate([
    (0, restricted_1.Whitelist)(),
    (0, property_1.Property)({ type: [mocks_1.ObjectId], default: [] }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "notificationQueuePatientIds", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "medicalLicenceNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "biography", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DoctorProfile.prototype, "maxVisitDurationMinutes", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => AvailabilityBlock),
    (0, property_1.Property)({ type: () => [AvailabilityBlock], default: [] }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "availability", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "iban", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "phone", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, property_1.Property)(),
    __metadata("design:type", Boolean)
], DoctorProfile.prototype, "videoCallAllowed", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, property_1.Property)({ index: true, sparse: true }),
    __metadata("design:type", Boolean)
], DoctorProfile.prototype, "displayInList", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DoctorProfile.prototype, "city", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.ADMINS] }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [mocks_1.ObjectId], default: [] }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "healthFacilityIds", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'healthFacilityIds', ref: 'HealthFacility', isArray: true }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "healthFacilities", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'specializationIds', ref: 'Specialization', isArray: true }),
    __metadata("design:type", Array)
], DoctorProfile.prototype, "specializations", void 0);
